const SECONDS_PER_WORD = {
  sloka: 0.65,
  meaning: 0.42
};

export function estimateTrackDuration(wordCount, trackType = 'sloka') {
  if (!wordCount) return 0;
  const rate = SECONDS_PER_WORD[trackType] || SECONDS_PER_WORD.sloka;
  return Math.max(wordCount * rate, 4);
}

/**
 * Maps playback progress to a word index when per-word timestamps are unavailable.
 * Uses real audio duration when available, otherwise estimates from word count.
 */
export function getActiveWordIndex(currentTime, duration, wordCount, trackType = 'sloka') {
  if (!wordCount) return -1;

  const effectiveDuration =
    duration > 0 ? duration : estimateTrackDuration(wordCount, trackType);

  if (!effectiveDuration) return 0;

  const progress = Math.min(Math.max(currentTime / effectiveDuration, 0), 0.999);
  return Math.min(Math.floor(progress * wordCount), wordCount - 1);
}

export function getPlaybackProgress(currentTime, duration, wordCount, trackType = 'sloka') {
  const effectiveDuration =
    duration > 0 ? duration : estimateTrackDuration(wordCount, trackType);

  if (!effectiveDuration) return 0;
  return Math.min(Math.max(currentTime / effectiveDuration, 0), 1);
}
